import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { server } from './server';

const baseQuery = fetchBaseQuery({
  baseUrl: server,
  prepareHeaders: (headers, { getState }) => {
    headers.set(
      'Authorization',
      `Bearer ${localStorage.getItem('kinesis:session')}`,
    );
    headers.set('Accept', 'application/json');
    headers.set('Content-type', 'application/json');
    const states = getState();
    const entities = states.featureFlags;
    const flags = entities
      ? Object.keys(entities).filter((key) => entities[key].enabled === true)
      : [];
    headers.set('Kinesis-Feature-Flags', flags.join(','));
  },
});

const api = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: [],
  endpoints: () => ({}),
});

export { api };
